import React, { useCallback } from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { useTranslations } from 'js/hooks/i18n';

import { Input } from '../Input';
import * as Types from './types';
import * as helpers from './helpers';
import * as hocs from './hocs/withFieldProps';

export const DateInputBare: React.FC<Types.IDateInputProps> = (props) => {
    const translate = useTranslations();
    const dateFormat = useAppSelector(prop('dateFormat'));
    const preventInput = useCallback((event: React.ChangeEvent) => event.preventDefault(), []);

    const handleKeyDown = useCallback((event: React.KeyboardEvent) => {
        const { key } = event;

        if (!new RegExp(/^[0-9]*$/).test(key) && key.length === 1) {
            event.preventDefault();
        }

    }, []);

    const handleOnInput = useCallback(
        (event: React.ChangeEvent<HTMLInputElement> & React.SyntheticEvent<HTMLInputElement, InputEvent>) => {
        const { target, nativeEvent: { inputType } } = event;
        const { separator } = helpers.getDateFormatData(dateFormat);
        let cleanDate = target.value.replaceAll(separator.sign, '');
        let cursorStart = target.selectionStart || 0;

        // insert first separator
        if (cleanDate.length > separator.firstIndex) {
            cleanDate = `${cleanDate.slice(0, separator.firstIndex)}${separator.sign}${cleanDate.slice(separator.firstIndex)}`;
        }

        // insert second separator
        if (cleanDate.length > separator.secondIndex) {
            cleanDate = `${cleanDate.slice(0, separator.secondIndex)}${separator.sign}${cleanDate.slice(separator.secondIndex)}`;
        }

        // if the cursor placed to the left of the separator, after "delete" it should appear to the right of it
        if ((target.selectionStart === separator.firstIndex || cursorStart === separator.secondIndex) && inputType === 'deleteContentForward') {
            cursorStart = cursorStart + 1;
        }

        // correction when adding a number it should be transferred through separator
        if ((cursorStart === separator.firstIndex + 1 || cursorStart === separator.secondIndex + 1) && inputType === 'insertText') {
            cursorStart = cursorStart + 1;
        }

        target.value = cleanDate;
        target.setSelectionRange(cursorStart, cursorStart);

    }, [dateFormat]);

    return (
        <Input
            inputMode="numeric"
            onCut={preventInput}
            onDrop={preventInput}
            onCopy={preventInput}
            onPaste={preventInput}
            onInput={handleOnInput}
            onKeyDown={handleKeyDown}
            onContextMenu={preventInput}
            maxLength={dateFormat.length}
            placeholder={dateFormat || props.placeholder}
            aria-label={props['aria-label'] || translate('playtech.mobile.system.input.date.aria-label')}
            {...props}
        />
    );
};

export const DateInput = hocs.withFieldProps(DateInputBare);
